<template>
    <ib-modal
        v-model="show"
        modalClass="col-4"
        :dismissable="true"
        >
            
        <div>
            <h5>Generate Advice Note</h5>
        </div>
        <div style="overflow-y: auto; height:600px">
        <div style="width:90%">
           <div class="row">
               <div class="col-4">
                   Part:
               </div>
               <div class="col-8">
                   {{order.partNumberForDisplay}}
               </div>
           </div>
           <div class="row">
               <div class="col-4">
                   Quantity:
               </div>
               <div class="col-8">
                   {{order.serverInfo.quantity}}
               </div>
           </div>
           <div class="row">
               <div class="col-4">
                   Unit Price:
               </div>
               <div class="col-8">
                   {{(order.serverInfo.price).toFixed(2)}}
               </div>
           </div>
           <div class="row">
               <div class="col-4">
                   Sub Total Price:
               </div>
               <div class="col-8">
                   {{(order.serverInfo.price * order.serverInfo.quantity).toFixed(2)}}
               </div>
           </div>
           <div class="row">
               <div class="col-4">
                   Depot:
               </div>
               <div class="col-8">
                   {{order.serverInfo.sellerDepotName}}
               </div>
           </div>
           <div class="row">
               <div class="col-4">
                   Buyer:
               </div>
               <div class="col-8">
                   {{order.serverInfo.buyerCompanyName}} <span v-if="order.serverInfo.buyerDepotName !== ''"> - {{order.serverInfo.buyerDepotName}}</span>
               </div>
           </div>
           
               
            <div class="row pt-3">
               <div class="col-4">
                   Carriage Part:
               </div>
               <div class="col-8">
                    <rs-dropdown
                        :ref="'carriagePartDropdown'"
                        :options="filteredMemoParts"
                        v-on:selected="memoPartSelected"
                        :disabled="memoPartsLoading"
                        :maxItem="100000"
                        placeholder="Select a Carriage Part">
                    </rs-dropdown>
               </div>
           </div>   
            <div class="row">
               <div class="col-4">
                   Carriage Charge:
               </div>
               <div class="col-8">
                   <input type="number" step="0.01" v-model="selectedCarriageCharge" style="width:100px" autocomplete="off"  min="0"/>
               </div>
           </div>
           <div class="row">
               <div class="col-4">
                   Customer Account:
               </div>
               <div class="col-8">
                   <rs-dropdown
                        :ref="'customerDropdown'"
                        :options="customers"
                        v-on:selected="customerSelected"
                        :disabled="customersLoading"
                        :maxItem="100000"
                        placeholder="Select a Customer Account">
                    </rs-dropdown>
               </div>
           </div>
           <div class="row">
               <div class="col-4">
               </div>
               <div v-if="selectedCustomerOnStop" class="col-8 alert alert-danger" role="alert">
                   Customer is on 'Total Stop'.
               </div>
            </div>
           <div class="row">
               <div class="col-4">
                   Operator:
               </div>
               <div class="col-8">
                   <rs-dropdown
                        :ref="'operatorDropdown'"
                        :options="filteredOperators"
                        v-on:selected="operatorSelected"
                        :disabled="operatorsLoading"
                        :maxItem="1000"
                        placeholder="Select an Operator"
                        >
                    </rs-dropdown>
               </div>
           </div>
            <div v-if="operatorPasswordRequired" class="row">
               <div class="col-4">
                   Operator Password:
               </div>
               <div class="col-8">
                   <form autocomplete="off">
                        <input type="password" v-model="operatorPassword" style="width:100px" autocomplete="off"/>
                   </form>
               </div>
           </div>
            <div class="row">
                <div class="col-4">
                </div>
                <div v-if="operatorPasswordError != ''" class="col-8 alert alert-danger" role="alert">
                    {{operatorPasswordError}}
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                </div>
                <div v-if="operatorPermissionError != ''" class="col-8 alert alert-danger" role="alert">
                    {{operatorPermissionError}}
                </div>
            </div>

            <div class="row pt-3">
               <div class="col-4">
                   Delivery Address:
               </div>
               <div class="col-8">
                   {{buyerDeliveryAddress}}
               </div>
           </div>
           <div class="row pt-3">
               <div class="col-4">
                   Billing Address:
               </div>
               <div class="col-8">
                   {{buyerBillingAddress}}
               </div>
           </div>
           <div class="text-muted pt-3"><i>Delivery &amp; Billing Address will be taken from the Buyer's profile</i></div>
                       
        </div>
        </div>
        <div class="text-right">
            <button type="button" class="btn btn-success" @click="generateAdviceNote" :disabled="!formValid">Generate Advice</button>
        </div>
    </ib-modal>
</template>
<script>
import IbModal          from '@/components/utilities/IbModal';
import RsDropdown       from '@/components/form/RomainSimonDropdown';
import SalesApi         from '@/common/sales';

export default {
    name: 'AdviceNoteModal',
    
    components: {
        RsDropdown,
        IbModal
    },

    created() {
    },

    data() {
        return {
            show                    : false,
            selectedCarriageCharge  : 0,
            selectedCarriagePart    : "",

            selectedCustomer        : "",
            selectedCustomerOnStop  : false,

            selectedOperator        : "",
            operatorPasswordRequired: false,
            operatorPassword        : "",
            operatorPasswordError   : "",
            operatorPermissionError : "",
        }
    },

    computed: {
        buyerBillingAddress() {
            let address = "";
            if (this.order.serverInfo.buyerBillingAddressLine1 !== "") {
                address = this.order.serverInfo.buyerBillingAddressLine1
            }
            if (this.order.serverInfo.buyerBillingAddressLine2 !== "") {
                address += ", " + this.order.serverInfo.buyerBillingAddressLine2
            }
            if (this.order.serverInfo.buyerBillingAddressLine3 !== "") {
                address += ", " + this.order.serverInfo.buyerBillingAddressLine3
            }
            if (this.order.serverInfo.buyerBillingAddressLine4 !== "") {
                address += ", " + this.order.serverInfo.buyerBillingAddressLine4
            }
            if (this.order.serverInfo.buyerBillingPostcode !== "") {
                address += ", " + this.order.serverInfo.buyerBillingPostcode
            }
            return address;
        },

        buyerDeliveryAddress() {
            let address = "";
            if (this.order.serverInfo.buyerDeliveryAddressLine1 !== "") {
                address = this.order.serverInfo.buyerDeliveryAddressLine1
            }
            if (this.order.serverInfo.buyerDeliveryAddressLine2 !== "") {
                address += ", " + this.order.serverInfo.buyerDeliveryAddressLine2
            }
            if (this.order.serverInfo.buyerDeliveryAddressLine3 !== "") {
                address += ", " + this.order.serverInfo.buyerDeliveryAddressLine3
            }
            if (this.order.serverInfo.buyerDeliveryAddressLine4 !== "") {
                address += ", " + this.order.serverInfo.buyerDeliveryAddressLine4
            }
            if (this.order.serverInfo.buyerDeliveryPostcode !== "") {
                address += ", " + this.order.serverInfo.buyerDeliveryPostcode
            }
            return address;
        },

        formValid() {
            // check valid customer and operator
            if(this.selectedCustomerOnStop || this.selectedCustomer == "" || this.selectedOperator == "" || this.selectedCarriagePart == "") {
                return false;
            }
            else
            {
                return true;
            }            

        },

        filteredOperators() {
            //only show operators for the selling depot who haven't left (can be null if they've never had a leaving date or "0001-01-01T00:00:00" if the date is later removed)
            return this.operators.filter(o => o.depot === this.order.serverInfo.sellerDepotNumber && (o.leavingDate == null || o.leavingDate == "0001-01-01T00:00:00"));
        },

        filteredMemoParts() {
            //only show memo parts for the selling depot
            return this.memoParts.filter(p => p.depot === this.order.serverInfo.sellerDepotNumber);
        },
    },

    props: {
        /**
         * The source of the v-model binding.
         */
        value: {
            required : true,
            type     : Boolean
        },
        order: {
            required : true,
            type     : Object
        },
        customers: {
            required : true,
            type     : Array
        },
        customersLoading: {
            required : true,
            type     : Boolean
        },
        operators: {
            required : true,
            type     : Array
        },
        operatorsLoading: {
            required : true,
            type     : Boolean
        },
        memoParts: {
            required : true,
            type     : Array
        },
        memoPartsLoading: {
            required : true,
            type     : Boolean
        }

    },

    methods: {
        async generateAdviceNote() {

            // todo: check operator and actually create the advice note
            let credentialCheck = await this.checkOperatorCredentials();
            let permissionCheck = await this.checkOperatorPermission();
            if(credentialCheck && permissionCheck) {
                let adviceNoteDetails = {
                    orderId        : this.order.serverInfo.id,
                    part           : this.order.partNumberForDisplay,
                    price          : Number(this.order.serverInfo.price),
                    quantity       : Number(this.order.serverInfo.quantity),
                    depot          : this.order.serverInfo.sellerDepotNumber,
                    carriagePart   : this.selectedCarriagePart, 
                    carriageCharge : Number(this.selectedCarriageCharge), 
                    customer       : this.selectedCustomer, 
                    operator       : this.selectedOperator,

                    contactName    : this.order.serverInfo.buyerContactName,

                    deliveryAddress1 : this.order.serverInfo.buyerDeliveryAddressLine1,
                    deliveryAddress2 : this.order.serverInfo.buyerDeliveryAddressLine2,
                    deliveryAddress3 : this.order.serverInfo.buyerDeliveryAddressLine3,
                    deliveryAddress4 : this.order.serverInfo.buyerDeliveryAddressLine4,
                    deliveryPostcode : this.order.serverInfo.buyerDeliveryPostcode,
                    
                    billingAddress1 : this.order.serverInfo.buyerBillingAddressLine1,
                    billingAddress2 : this.order.serverInfo.buyerBillingAddressLine2,
                    billingAddress3 : this.order.serverInfo.buyerBillingAddressLine3,
                    billingAddress4 : this.order.serverInfo.buyerBillingAddressLine4,
                    billingPostcode : this.order.serverInfo.buyerBillingPostcode,

                    purchaseOrderNumber : this.order.serverInfo.purchaseOrderNumber,

                    companyName         : this.order.serverInfo.buyerCompanyName,
                    depotName           : this.order.serverInfo.buyerDepotName
                    
                }
                this.$emit('generateAdviceNote', adviceNoteDetails);
            }
        },
        
        customerSelected(selection, name)
        {
            if(selection.option != undefined) {
                this.selectedCustomer = selection.option.id;
            }
            // grab customer object and check for total stop
            let customerObject =_.find(this.customers, c => c.id === this.selectedCustomer);
            if(customerObject !== undefined && customerObject.onStop == "Total Stop") {
                this.selectedCustomerOnStop = true;
            }
            else {
                this.selectedCustomerOnStop = false;
            }
        },
        
        memoPartSelected(selection, name)
        {
            if(selection.option != undefined) {
                this.selectedCarriagePart = selection.option.id;
            }
        },
                
        operatorSelected(selection, name)
        {
            if(selection.option != undefined) {
                this.selectedOperator = selection.option.id;
                // grab operator object and check for password
                let operatorObject =_.find(this.filteredOperators, o => o.id === this.selectedOperator);
                if(operatorObject !== undefined && operatorObject.password != undefined) {
                    this.operatorPasswordRequired = true;
                }
                else {
                    this.operatorPasswordRequired = false;
                }
                this.operatorPermissionError = "";
                this.operatorPasswordError = "";
            }
        },

            
        async checkOperatorCredentials() {
            console.debug("checking operator credentials");
            let operatorObject =_.find(this.filteredOperators, o => o.id === this.selectedOperator);
            let operatorToCheck = {storeman: operatorObject.id, aDepot : operatorObject.depot, password : this.operatorPassword.toUpperCase()};
            try {
                let credentialCheck = await SalesApi.checkOperatorCredentials(operatorToCheck);
                if(credentialCheck.data.success || this.operatorPasswordRequired === false) {
                    this.operatorPasswordError = "";
                    this.operatorPassword = "";
                    return true;
                }
                else
                {
                    this.operatorPasswordError = "Invalid Operator Password.";
                    return false;
                }
            }
            catch(error) {
                this.operatorPasswordError = error;
                return false;
            }
        },

        async checkOperatorPermission() {
            console.debug("checking operator permissions");
            let operatorObject =_.find(this.filteredOperators, o => o.id === this.selectedOperator);
            let operatorToCheck = {storeman: operatorObject.id, aDepot : operatorObject.depot, level : 1};
            try {
                let permissionCheck = await SalesApi.checkOperatorPermissions(operatorToCheck);
                if(permissionCheck.data.success) {
                    this.operatorPermissionError = "";
                    return true;
                }
                else
                {

                    this.operatorPermissionError = "'Raise Parts Invoices' Permission required.";
                    return false;
                }
            }
            catch(error) {
                this.operatorPermissionError = error;
                return false;
            }
        },
    },

    watch: {

        show(newValue) {
            this.$emit('input', this.show);
            this.selectedCarriageCharge = 0;
            this.selectedCustomer = "";
            this.selectedOperator = "";
            this.selectedCarriagePart = "";
            this.operatorPassword = "";
            this.operatorPasswordError = "";
            this.operatorPasswordRequired = false;
            if(this.selectedFilter === null) {
                this.clearSelectedFlags();
            }
        },

        value(newValue) {
            this.show = newValue;
        },
  
    }
    
}
</script>